/*
TODO if your class is so large that it warrants being split into multiple files
    a better solution might be to split up the class into multiple classes.
*/

const { default: fetch } = require("node-fetch")
import retry from "async-retry"
import { TOKKENR_NODE_HOST_URL } from "../../config"
import { toFixedDown } from "../../helpers/convert_bsv_tokens"

import { waitForSharedWhatsOnChainConnector } from "../../shared/WhatsOnChainConnector"
import { hasNestedProperty } from "../../shared/helpers"
import { banned_txhs } from "../RunContext"
const { getLog, deepcopy, removeDupsInArray, timestamp_to_ms } = require("../../helpers/helpers")

// load RUN through webpack externals
const Run = require("runlib")

/**
 * Deduplicates history entries by txhash (for token entries) or location (for
 * revoker/blacklist/multlist entries that don't have txhash).
 * A single tx can produce multiple token jig outputs (e.g. sent + change), and
 * removeDupsInArray() uses reference equality (indexOf) which fails for objects —
 * so without this, the same tx appears multiple times in the history display.
 */
function removeDupsByTxHashOrLocation(arr) {
    const seen = new Set()
    return arr.filter(item => {
        if (!item) return false
        // token entries have .txhash; non-token entries (revoker/blacklist/multlist) don't
        const key = item.txhash || item.location
        if (!key) return true // keep entries without a key (shouldn't happen, but safe)
        if (seen.has(key)) return false
        seen.add(key)
        return true
    })
}




const FETCH_TIMEOUT = 8000

/**
 * loads the history of this wallet's transactions
 */
export async function get_tx_history() {
    let function_id = this.classname + "get_tx_history(): "
    let log = getLog(function_id)

    get_tx_history_newversion = get_tx_history_newversion.bind(this)
    get_tx_history_old = get_tx_history_old.bind(this)

    let res
    const start_time = Date.now()
    /*
    I'm not even sure it's worth the pain to finish get_tx_history_newversion() ?
    it is a lot of work to parse the state received from the node
    and the node is already a big improvement even with the old version
    that it looks like *very* premature optimization
        example with address of 845 txs of which 19 are of target tokens:
            with cache: 2 secs to load
            after deleting cache: 167 secs to load (but it doesn't slow down anything else)
    => stale improvement attempt until it is actually needed
    */
    /*
    try {
        res = await get_tx_history_newversion()
        log("success using get_tx_history_newversion()")
    } catch (e) {
        log("failed with new version, using fallback get_tx_history_old() (which is slower)...")
        res = await get_tx_history_old()
        log("success using get_tx_history_old()")
    }
    //*/
    // res = await get_tx_history_newversion()
    res = await get_tx_history_old()
    log("finished in", (Date.now() - start_time), "ms")

    return res
}





class JigOriginChecker {
    constructor(
        tokenorigin, multlistjigorigin, accepted_multlist_origins, accepted_conversions_revokecount, accepted_revokers_origins,
        accepted_conversions_origins, accepted_blacklist_origins, blacklistjigorigin, revokercontractorigin
    ) {
        this.classname = "JigOriginChecker: "

        this.tokenorigin = tokenorigin
        this.multlistjigorigin = multlistjigorigin
        this.accepted_multlist_origins = accepted_multlist_origins
        this.accepted_conversions_revokecount = accepted_conversions_revokecount
        this.accepted_conversions_origins = accepted_conversions_origins
        this.accepted_blacklist_origins = accepted_blacklist_origins
        this.blacklistjigorigin = blacklistjigorigin
        this.revokercontractorigin = revokercontractorigin
        this.accepted_revokers_origins = accepted_revokers_origins
    }

    // not for mints! but for allow_convert_from_previous_contract()
    is_jig_of_tokenclass_origin(jig) {
        const log = getLog(this.classname + "is_jig_of_tokenclass_origin(): ")
        if (!jig) return false
        return (jig.origin === this.tokenorigin)  // main token class itself
    }

    is_jig_of_tokenorigin(jig) {
        const log = getLog(this.classname + "is_jig_of_tokenorigin(): ")

        if (!jig) return false
        if (jig.origin === this.tokenorigin) return false  // main token class itself
        if (jig.constructor.origin === this.tokenorigin) {
            /* || jig.origin == this.state.tokenorigin)
             jig.origin == this.state.tokenorigin in case we create & mint in the same tx
             // No in 0.6 it cannot happen since we check _oX here */
            log(" is_jig_of_tokenorigin(): found jig.action=" + jig.action
                + "\n oldest_mint_count = " + jig.oldest_mint_count + " \njig.amount=" + jig.amount
            )
            return true
        }

        const accepted_conversions_revokecount = this.accepted_conversions_revokecount,
            accepted_conversions_origins = this.accepted_conversions_origins

        // now we also need to check in the accepted_conversions

        /*
        var cond = (val)=>{ return jig.constructor.origin == val}
        var reducer = (accumulator, currval)=>accumulator || cond(currval) // || because we only need 1
        return accepted_conversions_origins.reduce(reducer, false) // false as the default
        *//* // but this didn't check the revoke_count after a revoke !
        return accepted_conversions_origins.includes(jig.constructor.origin) */

        var indexof = accepted_conversions_origins.indexOf(jig.constructor.origin)
        if (indexof === -1) return false  // not found

        // else if found let's check if after revoke_count
        var curr_revoke_count = accepted_conversions_revokecount[indexof]
        log(" >>> token with action= " + jig.action + " owner= " + jig.owner + " " + jig.amount
            + " jig.oldest_mint_count= " + jig.oldest_mint_count + " vs curr_revoke_count= " + curr_revoke_count)

        if (curr_revoke_count == null) return true

        // BEWARE DO NOT USE JUST if(!jig.oldest_mint_count) because it will return false for 0
        if (!jig.hasOwnProperty("oldest_mint_count")) return false
        if (jig.oldest_mint_count >= curr_revoke_count) return false
        return true
        /* accepted_conversions_origins.forEach((conversion_origin) => {
            if(jig.origin == conversion_origin) return false // main token class itself
            if(jig.constructor.origin == conversion_origin) return true
        })
        return false
        */
    }

    is_jig_of_multlist_origin(jig) {
        const log = getLog(this.classname + "is_jig_of_multlist_origin(): ")
        if (!jig) return false
        if (jig.defaultval) return false  // only for multlist because we overwrite the first mult of 1.0

        const multlistjigorigin = this.multlistjigorigin,
            accepted_multlist_origins = this.accepted_multlist_origins,
            accepted_conversions_revokecount = this.accepted_conversions_revokecount
        /* console.log(" is_jig_of_multlist_origin(): \n"+"jig.list = "+jig.list+"\n "+" multlistjigorigin = "
         +multlistjigorigin+" \n jig.constructor.origin = ",jig.constructor.origin,"\n jig.origin = ",jig.origin) */
        if (jig.origin === multlistjigorigin) {
            log("is_jig_of_multlist_origin(): found \n jig.list = " + jig.list + "\n multlistjigorigin == jig.origin = " + multlistjigorigin)
            return true
        }

        var indexof = accepted_multlist_origins.indexOf(jig.origin)
        if (indexof === -1) return false // not found
        // else if found let's check if after revoke_count
        var curr_revoke_count = accepted_conversions_revokecount[indexof]
        if (curr_revoke_count == null) return true
        // beware here we can test like that because list_action_numbers is an array and not just a var that could have a value of 0
        if (!jig.list_action_numbers) return false
        // last action_number if the current one
        var jig_action_count = jig.list_action_numbers[jig.list_action_numbers.length - 1]
        if (jig_action_count >= curr_revoke_count) return false
        return true
        /* var cond = (val)=>{ return jig.origin == val}
        var reducer = (accumulator, currval)=>accumulator || cond(currval) // || because we only need 1
        return accepted_multlist_origins.reduce(reducer, false) // false as the default
        *//*
        accepted_multlist_origins.forEach( (old_multlist_origin) => {
            if(jig.origin == old_multlist_origin) return true
            else return false
        })
        return false
        */
    }

    is_jig_of_blacklist_origin(jig) {
        const log = getLog(this.classname + "is_jig_of_blacklist_origin(): ")
        if (!jig) return false
        if (jig.origin === this.blacklistjigorigin) return true

        const accepted_blacklist_origins = this.accepted_blacklist_origins,
            accepted_multlist_origins = this.accepted_multlist_origins,
            accepted_conversions_revokecount = this.accepted_conversions_revokecount

        // now we also need to check in the accepted_conversions
        if (accepted_blacklist_origins.includes(jig.origin)) return true
        //
        var indexof = accepted_multlist_origins.indexOf(jig.origin)
        if (indexof === -1) return false  // not found

        // else if found let's check if after revoke_count
        var curr_revoke_count = accepted_conversions_revokecount[indexof]
        if (curr_revoke_count == null) return true

        // beware here we can test like that because list_action_numbers is an array and not just a var that could have a value of 0
        if (!jig.list_action_numbers) return false
        // last action_number if the current one
        var jig_action_count = jig.list_action_numbers[jig.list_action_numbers.length - 1]
        if (jig_action_count >= curr_revoke_count) return false
        return true

        /*
            var cond = (val)=>{ return jig.origin == val}
            var reducer = (accumulator, currval)=>accumulator || cond(currval) // || because we only need 1
            return accepted_blacklist_origins.reduce(reducer, false) // false as the default
        */
        /*
            accepted_blacklist_origins.forEach(  (old_blacklist_origin) => {
                if(jig.origin == old_blacklist_origin) return true
                else return false
            })
            return false
        */
    }


    is_jig_of_revokercontract_origin(jig) {
        const log = getLog(this.classname + "is_jig_of_revokercontract_origin(): ")
        if (!jig) return false
        if (jig.origin === this.revokercontractorigin) return true

        const accepted_revokers_origins = this.accepted_revokers_origins

        // now we also need to check in the accepted_conversions
        return accepted_revokers_origins.includes(jig.origin)

        /* var cond = (val)=>{ return jig.origin == val}
        var reducer = (accumulator, currval)=>accumulator || cond(currval) // || because we only need 1
        return accepted_revokers_origins.reduce(reducer, false) // false as the default
        */
    }

    /*
    var is_jig_of_allow_convert_from_previous_contract_origin = function (jig){
        if(!jig) return false
        if(jig.action != "allow_convert_from_previous_contract") return false
        if(jig.origin == tokenoriginjig.origin) return true
        // now we also need to check in the accepted_conversions
        accepted_conversions_origins.forEach((conversion_origin) => {
            if(jig.origin == conversion_origin) return true
        })
        return false
    }.bind(this)
    */
}




/**
 * fetches if needed a tx from the chain and parses its outputs for the history display
 * 
 * @param myrun should already be loaded & synced
 */
async function get_tx_history_loadfromblockchain(
    myrun, txhash, totalmult, tokenoriginjig, multlistjigorigin, blacklistjigorigin,
    revokercontractorigin, multlist, multlist_timestamps
) {
    var function_id = "get_tx_history_loadfromblockchain(): "
    const log = getLog(function_id)

    // comme une transaction RUN peut combiner plusieurs opérations (outputs / locations)
    // => il faut trouver les suffixes dynamiquement

    var tx = null
    try {
        if (banned_txhs.includes(txhash)) {
            log("DETECTED BANNED TX, returning immediately for", txhash)
            return []
        }

        log("txhash : " + txhash)
        tx = await myrun.blockchain.fetch(txhash)
    }
    catch (error) {
        this.throwContextError(error, function_id + ".3 : txhash=" + txhash)
    }
    // log("get_tx_history tx.outputs = ",tx.outputs)

    var nbcodes, nbactions, hasopreturn = true, nbouts, payload
    try {
        payload = Run.util.metadata(tx)
        // log("tx payload : ", payload)

        nbouts = payload.out.length
        /* // payload.cre contains the owners of the new jigs created
        log("nb created =",payload.cre.length, "nb outs =",nbouts) */
        hasopreturn = true
    }
    catch (error) {
        // WE ABSOLUTELY WANT TO THROW HERE - NEVER OPEN A RUN ADDRESS AS A BSV WALLET
        this.throwContextError(error, function_id + ".3.5 : txhash=" + txhash)
    }

    if (!hasopreturn) return []
    var finaltxdata_array = []

    try {
        nbcodes = 0
        nbactions = nbouts
        log("nbactions=", nbactions)

        // THERE MIGHT BE SEVERAL ACTIONS so we need to check them all, ex: combine then send
        for (var i_nbactions = 0; i_nbactions < nbactions; i_nbactions++) {

            var finaltxdata = null
            var suffix = "_o" + (nbcodes + i_nbactions + 1)
            const jig_location = txhash + suffix

            var accepted_conversions = tokenoriginjig.accepted_conversions  // [origin, revoke_count]
            const accepted_conversions_origins = []
            const accepted_conversions_revokecount = []

            if (accepted_conversions) {
                for (let i = 0; i < accepted_conversions.length; i++) {
                    accepted_conversions_origins.push(accepted_conversions[i][0])
                    accepted_conversions_revokecount.push(accepted_conversions[i][1])
                }
            }
            const accepted_multlist_origins = []
            const accepted_blacklist_origins = []
            const accepted_revokers_origins = []

            // because we need to check the subcontracts we load all accepted_conversions as jigs
            // but we don't need to sync them!
            for (let i = 0; i < accepted_conversions_origins.length; i++) {
                var accepted_conversion_origin = accepted_conversions_origins[i]
                myrun.trust(accepted_conversion_origin.split('_')[0])

                await myrun.cache.set("ban://" + accepted_conversion_origin, false)  // make sure we can load it

                var accepted_conversion_jig = await myrun.load(accepted_conversion_origin)
                // do not sync because we only care about origins !
                accepted_multlist_origins.push(accepted_conversion_jig.multlist.origin)
                accepted_blacklist_origins.push(accepted_conversion_jig.blacklist.origin)
                accepted_revokers_origins.push(accepted_conversion_jig.revokercontract.origin)
            }

            const jigOriginChecker = new JigOriginChecker(
                this.state.tokenorigin,
                multlistjigorigin, accepted_multlist_origins, accepted_conversions_revokecount, accepted_revokers_origins,
                accepted_conversions_origins, accepted_blacklist_origins, blacklistjigorigin, revokercontractorigin
            )

            const is_tokenclass = (jig) => { return jigOriginChecker.is_jig_of_tokenclass_origin(jig) },
                is_multlist = (jig) => { return jigOriginChecker.is_jig_of_multlist_origin(jig) },
                is_token = (jig) => { return jigOriginChecker.is_jig_of_tokenorigin(jig) },
                is_blacklist = (jig) => { return jigOriginChecker.is_jig_of_blacklist_origin(jig) },
                is_revoker = (jig) => { return jigOriginChecker.is_jig_of_revokercontract_origin(jig) }

            var jig = null;
            try {
                myrun.activate()
                console.log(function_id + "trying to load jig at " + txhash + suffix)

                // 22.12.2021 TODO find a way to remove that, it makes wallet too slow on first load,
                // because it will load ALL contracts & refs contracts of ALL tx, not just the ones we want!
                // note IF THE TX IS NOT TRUSTED, WE SHOULDNT DISPLAY IT AND THUS DONT NEED TO LOAD IT !
                jig = await myrun.load(txhash + suffix)  // DO NOT SYNC THIS JIG because we need the timestamp not synced!
                console.log(function_id + "successfully loaded jig at " + txhash + suffix)
            }
            catch (error) {
                // if it's not of the tokenorigin we are trying to load, we don't care about the error
                const logLoadJigError = (check_funcname) => {
                    console.error(function_id + ": potential error loading jig (v1) at " + txhash + suffix
                        + " : " + check_funcname + "(jig) = true \n error: ", error)
                }
                if (is_token(jig)) logLoadJigError("is_jig_of_tokenorigin")
                else if (is_multlist(jig)) logLoadJigError("is_jig_of_multlist_origin")
                else if (is_blacklist(jig)) logLoadJigError("is_jig_of_blacklist_origin")
                else if (is_revoker(jig)) logLoadJigError("is_jig_of_revokercontract_origin")
                else if (is_tokenclass(jig)) logLoadJigError("is_jig_of_tokenclass_origin")
                else {
                    // we don't care and don't throw //throw function_id+error
                    // BUG HERE IF WE GET A INVENTORY SYNC TIMEOUT ERROR AND NEVER THROW
                    // then we never load the wallet and remain stuck in a loading state
                    let error_str = error.toString()
                    // make a cleaned version that removes any html code
                    let error_str_cleaned = error_str.split("<html>")[0]
                    let errormess = function_id + ": potential error loading jig (v2) at " + txhash + suffix + ": "

                    if (error_str.includes("timeout") || error_str.includes("Timeout")) {
                        console.error(function_id + "DETECTED TIMEOUT:", error)
                        throw error
                    }
                    else if (error_str.includes("503 Service Temporarily Unavailable")) {
                        // beware 'BlockchainNodeError' is referenced in translateErrorToJSXMessage.js
                        errormess += "BlockchainNodeError: 503 Service Temporarily Unavailable: "
                            + error_str_cleaned
                        console.error(errormess, error)
                        throw new Error(errormess)
                    }
                    else {
                        console.error(errormess, error)
                    }
                }
            }

            log("trying to find which type the jig is...")

            // Case: allow_convert_from_previous_contract()
            // abort we don't want any of the jigs in outputs to be analyzed, we already show backup or revoke separately
            // beware this function shoudl return an array !
            //
            // PROBLEM EACH MINT, BLACKLIST ETC WILL SPEND THE CLASS INCREASING THE NONCE
            //
            if (is_tokenclass(jig) && jig.action === "allow_convert_from_previous_contract") {
                log("jig is token class")
                payload = Run.util.metadata(tx)
                console.log(function_id + " allow_convert_from_previous_contract found :\n", jig, " \n payload = ", payload)
                return [null]
            }

            var curr_timestamp
            if (is_revoker(jig) && jig.revoked_state && jig.revoked_state.length > 0) { // revoked_state.length to not show the init
                log("jig is revoker")

                var action = jig.revoked_state

                if (!jig.timestamp) throw (function_id + " revoker: error missing timestamps for " + txhash, jig)
                curr_timestamp = jig.timestamp

                const manual_timestamp = timestamp_to_ms(curr_timestamp) // recup timestamp manuel plus précis que celui du block
                const timestamp_and_blockheight = await this.get_final_timestamp_and_blockheight(myrun, txhash, manual_timestamp)
                // const final_timestamp  = timestamp_in_ms(timestamp_and_blockheight[0])
                const final_timestamp = manual_timestamp // revoker actions are from admin so we always trust the timestamp
                const tx_blockheight = timestamp_and_blockheight[1]

                const txdate = new Date(final_timestamp)
                const str_txdate = txdate.toLocaleString("fr-FR")

                finaltxdata = {
                    date: str_txdate,
                    action: action,
                    timestamp: final_timestamp,
                    location: jig_location,
                    blockheight: tx_blockheight,
                    tokenorigin: tokenoriginjig.origin,
                }
                if (jig.new_token_contract) finaltxdata.new_token_contract_origin = jig.new_token_contract.origin
                if (jig.revoke_count) finaltxdata.revoke_count = jig.revoke_count

                console.log(function_id + ": REVOKE ACTION " + action + " \n", finaltxdata)
            }
            else if (is_blacklist(jig) && jig.list && jig.list.length > 0) // jig.list conditions to not show the init & linkadmincounter actions
            {
                log("jig is blacklist")
                var action_count = jig.action_count
                action = "blacklist"

                if (!jig.timestamps) throw new Error(function_id + " blacklist: error missing timestamps for " + txhash)
                curr_timestamp = jig.timestamps[jig.timestamps.length - 1]  // last value

                const manual_timestamp = timestamp_to_ms(curr_timestamp)  // recup timestamp manuel plus précis que celui du block
                const timestamp_and_blockheight = await this.get_final_timestamp_and_blockheight(myrun, txhash, manual_timestamp)
                // const final_timestamp  = timestamp_in_ms(timestamp_and_blockheight[0])
                const final_timestamp = manual_timestamp // revoker actions are from admin so we always trust the timestamp
                const tx_blockheight = timestamp_and_blockheight[1]

                const txdate = new Date(final_timestamp)
                const str_txdate = txdate.toLocaleString("fr-FR")

                finaltxdata = {
                    date: str_txdate,
                    action: action,
                    timestamp: final_timestamp,
                    location: jig_location,
                    blockheight: tx_blockheight,
                    action_count: action_count,
                }
                finaltxdata.blacklisted_address = jig.list[jig.list.length - 1]  // last value

                console.log(function_id + ": BLACKLIST ACTION " + action + " \n", finaltxdata)
            }
            // jig.list conditions to not show the init & linkadmincounter actions
            else if (is_multlist(jig) && jig.list && jig.list.length > 0) {
                log("is_jig_of_multlist_origin true, PUBLISH MINTUPLE jig found, list : " + jig.list)

                action_count = jig.action_count
                action = "mintuple"
                var new_mintuple = jig.list[jig.list.length - 1]  // last mintuple

                if (!jig.timestamps) throw new Error(function_id + " multlist: error missing timestamps for " + txhash)
                curr_timestamp = jig.timestamps[jig.timestamps.length - 1]  // last value

                const manual_timestamp = timestamp_to_ms(curr_timestamp)  // recup timestamp manuel plus précis que celui du block
                const timestamp_and_blockheight = await this.get_final_timestamp_and_blockheight(myrun, txhash, manual_timestamp)
                // const final_timestamp  = timestamp_in_ms(timestamp_and_blockheight[0])
                const final_timestamp = manual_timestamp // revoker actions are from admin so we always trust the timestamp
                const tx_blockheight = timestamp_and_blockheight[1]

                const txdate = new Date(final_timestamp)
                const str_txdate = txdate.toLocaleString("fr-FR")

                finaltxdata = {
                    date: str_txdate,
                    action: action,
                    timestamp: final_timestamp,
                    location: jig_location,
                    blockheight: tx_blockheight,
                    action_count: action_count,
                }

                finaltxdata.mintuple = new_mintuple  // this is the one that is actually being shown in Slide_History

                console.log(function_id + ": PUBLISH MINTUPLE " + new_mintuple + " \n", finaltxdata, "\n  from list : " + jig.list)
            }
            else if (is_token(jig) && jig.action !== "combine" && jig.action !== "change") {
                try {
                    log("jig is a token")
                    if (!jig.timestamp) throw new Error(function_id + " token: error missing timestamp for " + txhash)
                    const manual_timestamp = timestamp_to_ms(jig.timestamp)  // recup timestamp manuel plus précis que celui du block
                    log("token: manual_timestamp=", manual_timestamp)
                    const timestamp_and_blockheight = await this.get_final_timestamp_and_blockheight(myrun, txhash, manual_timestamp)
                    log("token: timestamp_and_blockheight=", timestamp_and_blockheight)

                    // it probably was a smartcontract mistake to not allow a send with a manual_timestamp that is before the previous one
                    // because of this, we need to check if coins received have a manual_timestamp not too far into the future
                    // before showing them in the wallet
                    // const final_timestamp = manual_timestamp  // use this to always trust the manual timestamp
                    const final_timestamp = timestamp_to_ms(timestamp_and_blockheight[0])
                    log("token: final_timestamp=", final_timestamp)
                    const tx_blockheight = timestamp_and_blockheight[1]
                    log("token: tx_blockheight=", tx_blockheight)

                    const txdate = new Date(final_timestamp)
                    const str_txdate = txdate.toLocaleString("fr-FR")

                    log("token: jig =\n", deepcopy(jig), "\npayload:\n", deepcopy(payload))

                    action = jig.action
                    var receiver = jig.owner
                    var decimals = null, decimalsDisplay = null
                    // jig.origin == this.state.tokenorigin in case we create & mint in the same tx
                    if (!jig.constructor.decimals) {
                        decimalsDisplay = jig.decimalsDisplay
                        decimals = jig.decimals
                    } else {
                        decimalsDisplay = jig.constructor.decimalsDisplay
                        decimals = jig.constructor.decimals
                    }
                    var sender = receiver // default
                    if (action === "send") {
                        if (!jig.sender) throw new Error(function_id + " jig.sender is '" + jig.sender + "' for " + txhash)
                        sender = jig.sender
                    }

                    action_count = null
                    if (action === "mint") action_count = jig.oldest_mint_count


                    log("\n\t action     = " + action
                        + "\n\t sender     = " + sender
                        + "\n\t receiver   = " + receiver
                        + "\n\t date       = " + str_txdate
                        + "\n\t final_timestamp  = " + final_timestamp
                        + "\n\t blockheight      = " + tx_blockheight
                        + "\n\t decimalsDisplay  = " + decimalsDisplay
                        + "\n\t decimals     = " + decimals
                        + "\n\t txhash       = " + txhash
                        + "\n\t amount       = " + parseInt(jig.amount)
                        + "\n\t action_count = " + action_count
                    )

                    finaltxdata = {
                        date: str_txdate,
                        action: action,
                        sender: sender,
                        receiver: receiver,
                        timestamp: final_timestamp,
                        location: jig_location,
                        decimalsDisplay: decimalsDisplay,
                        decimals: decimals,
                        blockheight: tx_blockheight,
                        amount: parseInt(jig.amount),
                        action_count: action_count,
                        txhash: txhash,
                    }

                    if (action === "burn") {
                        finaltxdata.amount = jig.amount_burnt
                    }

                    if (finaltxdata != null) {  // unknown action, more than 2 actions but no send found

                        // now check if we are owner or not to know if it is receiving or sending, minting etc
                        // var purseaddress = myrun.purse.address.toString() // only for run 0.5
                        var owneraddress = myrun.owner.address.toString()
                        totalmult = parseFloat(totalmult)

                        /* calculate the timestamps up to that tx
                         beware because these are timestamps of blocks so they can be the same!!
                         if a tx and a new multiplicator are in the same block, the mult will be applied to the tx anyway
                         so multiplicators should be published when there is low activity on the network
                         a solution could be to add timestamps to Mult->publish() & mint() &  Token->send() and check that the timestamp
                            is between last_block_timestamp and current_block_timestamp, otherwise take current_block_timestamp
                              another solution would be to not use timestamps but rather block_eight & transaction ordering,
                            assuming first tx happen before
                         the tx # in the block can be computed from the merkle proof which is easy to obtain (by checking the list of left/right),
                            see https://learnmeabitcoin.com/guide/merkle-root
                              another solution would be to link the multiplicator contract IN the token contract, and write the token contract
                         so that before sending we load the multlist & include it into the sending tx! or maybe we link the
                            last location of the multlist contract ?
                         not sure this is much better than the manual timestamps with validity verification solution.
                        */

                        var txtime = timestamp_to_ms(finaltxdata.timestamp)
                        var maxidx = -1
                        var mults_to_txtime = []

                        // si la transaction à été faite après TOUS les multiplicateus
                        if (txtime > multlist_timestamps[multlist_timestamps.length - 1]) {
                            maxidx = multlist_timestamps.length
                        } else {
                            // sinon on recup juste les multiplicateurs concernés
                            for (var i_timestamps = 0; i_timestamps < multlist_timestamps.length; i_timestamps++) {
                                var currtime = multlist_timestamps[i_timestamps]
                                if (currtime > txtime) {
                                    maxidx = i_timestamps
                                    break
                                }
                                /*
                                else if(i_timestamps==multlist_timestamps.length-1){
                                    maxidx = multlist_timestamps.length
                                }*/
                            }
                        }
                        mults_to_txtime = multlist.slice(0, maxidx)  // note: the max value is not taken with slice!

                        let totalmult_to_txtime = 1.0
                        mults_to_txtime.forEach(elem => totalmult_to_txtime *= elem)

                        log("\n txtime              = " + txtime
                            + "\n multlist            = " + multlist
                            + "\n multlist_timestamps = " + multlist_timestamps
                            + "\n maxidx              = " + maxidx
                            + "\n mults_to_txtime     = " + mults_to_txtime
                            + "\n totalmult_to_txtime = " + totalmult_to_txtime
                        )

                        // a mint is when you "init" with receiver=owner (& with sender=purse ??)  // comment distinguer d'un combine ?? 
                        if (action === "mint" && finaltxdata.receiver === owneraddress
                            && finaltxdata.sender === owneraddress) {
                            finaltxdata.action = "mint"
                            // we add + 0.001 to make sure to not display 499.99 instead of 500
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = +finaltxdata.amount

                            finaltxdata.action_count = jig.oldest_mint_count

                            log("MINT " + finaltxdata.txtime_val + " Delphes with action# "
                                + finaltxdata.action_count + "\n", finaltxdata)
                        }
                        else if (action === "burn") {
                            finaltxdata.action = "burn"
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = -finaltxdata.amount

                            finaltxdata.action_count = jig.action_count

                            log("BURN " + finaltxdata.txtime_val + " Delphes with action# "
                                + finaltxdata.action_count + "\n", finaltxdata)
                        }
                        // now detect sending to oneself
                        else if (action === "send" && finaltxdata.sender === finaltxdata.receiver) {
                            finaltxdata.action = "send_to_yourself"
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = 0
                            log("SENDING TO YOURSELF " + finaltxdata.txtime_val + " Delphes", finaltxdata)

                        }
                        else if (action === "send" && finaltxdata.sender === owneraddress) {
                            finaltxdata.action = "send"
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = -finaltxdata.amount
                            log("SEND " + finaltxdata.txtime_val + " Delphes", finaltxdata)

                        }
                        else if (action === "send" && finaltxdata.sender !== owneraddress
                            && finaltxdata.receiver === owneraddress) {
                            finaltxdata.action = "receive"
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = +finaltxdata.amount
                            log("RECEIVE " + finaltxdata.txtime_val + " Delphes", finaltxdata)
                        }
                        else if (action === "convert" && finaltxdata.sender === finaltxdata.receiver) {
                            finaltxdata.action = "convert"
                            finaltxdata.premult_val = finaltxdata.amount / Math.pow(10, finaltxdata.decimals) + 0.001
                            finaltxdata.txtime_val = toFixedDown((finaltxdata.premult_val * totalmult_to_txtime), 2)
                            finaltxdata.effect_amount = 0
                            log("CONVERT COINS TO NEW CONTRACT " + finaltxdata.txtime_val + " Delphes", finaltxdata)
                        }
                        /*
                        else if(action=="init" && finaltxdata.sender == owneraddress && finaltxdata.receiver == owneraddress) {
                            if(jig.location == jig.origin) {  // it seems like it is most probably the initial mint in that case
                                console.error(function_id+" probably initial mint, to verify: "+jig.location)
                                finaltxdata.action = "mint"
                                //finaltxdata.amount = parseInt(action.args[0])// run 0.5
                                finaltxdata.amount = finaltxdata.amount // run 0.6
                                finaltxdata.premult_val  = finaltxdata.amount/Math.pow(10,finaltxdata.decimals)
                                finaltxdata.txtime_val   = (finaltxdata.premult_val*totalmult_to_txtime).toFixedDown(2)
                                finaltxdata.postmult_val = (finaltxdata.premult_val*totalmult).toFixedDown(2)
                                finaltxdata.effect_amount = +finaltxdata.amount
                                finaltxdata.action_count = jig.oldest_mint_count
                                console.log(function_id+": MINT "+finaltxdata.txtime_val
                                    +" Tokens with action# "+finaltxdata.action_count+"\n",finaltxdata)
                            } else {
                                console.error(
                                    function_id+": unknown TX in wallet & NOT initial mint of tokens, maybe combine? : ",
                                    finaltxdata,"\n\t jig.location="+jig.location+"\n\t jig.origin="+jig.origin
                                )
                            }							
                        }
                        */
                        else if (action === "combine") {
                            console.error(function_id + ": combine TX in wallet for " + txhash + ": \n", finaltxdata)
                        }
                        else {
                            console.error(function_id + ": unknown TX in wallet for " + txhash + ": \n", finaltxdata)
                        }
                    }
                }
                catch (error) {
                    this.throwContextError(error, function_id + ".4 : txhash=" + txhash + ": ")
                }
            } else {
                // we don't recognize this jig as a token, multlist or something we are looking for
                // so we do nothing
            }
            if (finaltxdata != null) finaltxdata_array.push(finaltxdata)
        }
    }
    catch (error) {
        this.throwContextError(error, function_id + ".5 : ")
    }
    return finaltxdata_array
}




async function fetch_tokkenr_node_for_address_token_history(owner_address, class_origin) {
    const function_id = "fetch_tokkenr_node_for_address_token_history("
        + owner_address + ", " + class_origin + "): "
    const log = getLog(function_id)
    log("start")

    // only specify a class if one was passed as param
    let class_param = ""
    if (class_origin) {
        class_param = "&class=" + class_origin
    }

    const full_url = TOKKENR_NODE_HOST_URL
        + "/history?address=" + owner_address + class_param

    log("fetching history from", full_url)
    let data = await fetch(full_url, { timeout: FETCH_TIMEOUT })
    data = await data.json()
    log("data = ", data)
    return data
}

async function fetch_tokkenr_node_for_tx_status(txhash) {
    const function_id = "fetch_tokkenr_node_for_tx_status(" + txhash + "): "
    const log = getLog(function_id)

    if (!txhash) throw new Error(function_id + "missing txhash, got:" + txhash)

    const full_url = TOKKENR_NODE_HOST_URL + "/status/" + txhash
    let data = await fetch(full_url, { timeout: FETCH_TIMEOUT })
    data = await data.json()
    log("data = ", data)
    return data
}


async function fetch_tokkenr_node_for_status_txhash(txhash_or_location) {
    const function_id = "fetch_tokkenr_node_for_status_txhash(" + txhash_or_location + "): "
    const log = getLog(function_id)
    log("start")

    const txhash = txhash_or_location.split("_")[0]
    const full_url = TOKKENR_NODE_HOST_URL + "/status/" + txhash

    log("fetching /status/txhash from", full_url)
    let data = await fetch(full_url, { timeout: FETCH_TIMEOUT })
    data = await data.json()
    log("data = ", data)
    return data
}



async function parse_tx_states_to_txdata_array(
    txh_status_data,
    myrun, txhash, totalmult, tokenoriginjig, multlistjig_origin, blacklistjig_origin,
    revokercontract_origin, multlist, multlist_timestamps
) {
    let function_id = "parse_tx_states_to_txdata_array(): "
    let log = getLog(function_id)

    // for the expected format check "output_res" below in this function
    const txdata_array = []

    log("txh_status_data=", txh_status_data, "\n\n", JSON.stringify(txh_status_data))
    const txh = txh_status_data.txh
    const timestamp_ms = txh_status_data.time * 1000
    const date_str = (new Date(timestamp_ms)).toLocaleString("fr-FR")

    await tokenoriginjig.sync()
    log("tokenoriginjig=", tokenoriginjig)
    log("tokenoriginjig.decimalsDisplay=", tokenoriginjig.decimalsDisplay)
    log("tokenoriginjig.decimals=", tokenoriginjig.decimals)
    log("totalmult=", totalmult, "from multlist=", multlist)

    let i = 0
    for (let output_data of txh_status_data.outputs) {
        log("output", i, "=", output_data)
        if (hasNestedProperty(output_data, "state")) {
            const output_state = output_data.state
            log("output_state=", output_state)
            let jig_class_origin = output_state.cls["$jig"]
            if (jig_class_origin[0] == '_') jig_class_origin = txh + jig_class_origin

            output_res = {
                txhash: txh,
                timestamp: timestamp_ms,
                date: date_str,
                amount: output_data.amount,

                /* REALIZED THIS IS A LOT OF PAIN
                    and probably for not much optimization
                    so this is a stale improvement attempt until it becomes actually needed.
                */
                // action: "send",
                // action_count: null,
                // blockheight: 777295,
                // date: "01/02/2023 22:04:23",
                // decimals: 8,
                // decimalsDisplay: 2,
                // effect_amount: -55757771,
                // location: "b00529edad5a8893e1b2f398bc388404de9c8d063f1b6c7ce4bdc02a2946ad1a_o1",
                // premult_val: 0.55857771,
                // receiver: "1MtdNjRwvq3YbrwfhzezpYektaeZFdHYrL",
                // sender: "12xRS4tNHSQJqUTfXZ2Zts8iBA2xPi4qMa",
                // txtime_val: 1,
            }
            txdata_array.push(output_res)
        }
        i += 1
    }

    throw new Error("TEST ERROR")

    return txdata_array
}



/**
 * loads the history of this wallet's transactions
 * (this new version because it doesn't load each old token jig that isn't in utxos anymore,
 *  which is much faster but relies heavily on tokkenR node)
 */
async function get_tx_history_newversion() {
    let function_id = this.classname + "get_tx_history_newversion(): "
    let log = getLog(function_id)

    // Dont do this! we still need to be able to sync
    // abort if we need to exchange tokens
    // if (this.state.revokedetected) throw new Error(function_id + "aborting because revokedetected")
    if (!this.wallet_history_cache) throw new Error(function_id + "missing this.wallet_history_cache")

    log("wallet_history_cache.size:", this.wallet_history_cache.size,
        "wallet_history_cache.last_seen_height=", this.wallet_history_cache.last_seen_height)

    var myrun = null, owner_address = null, totalmult = null, multlistjig = null,
        multlist = null, multlist_timestamps = null, tokenoriginjig, blacklistjig, revokercontract


    // --- retrieve needed components ---

    log("step 1")
    try {
        // parallel calls for faster app
        var [myrun, tokenoriginjig, multlistjig, totalmult] = await Promise.all([
            await this.runContext.get_run_asyncf(),
            this.get_tokenoriginjig(),
            this.get_multlistjig_synced(),
            this.get_total_mult(),
        ])

        owner_address = myrun.owner.address
        log = getLog(function_id + "for " + owner_address + " :")  // udpate log function with more info

        // REMINDER: NEVER LOG RUN IT CONTAINS PRIVKEYS
        log("tokenoriginjig=", tokenoriginjig, ", multlistjig=", multlistjig, ", totalmult=", totalmult)
        log("step 2")

        await tokenoriginjig.sync()
        log("step 3")

        blacklistjig = tokenoriginjig.blacklist
        if (!blacklistjig) throw new Error(function_id + " no blacklist found in tokenoriginjig")

        revokercontract = tokenoriginjig.revokercontract
        if (!revokercontract) throw new Error(function_id + " no revokercontract found in tokenoriginjig")

        multlist = deepcopy(multlistjig.list)
        multlist_timestamps = deepcopy(multlistjig.timestamps)
    }
    catch (error) {
        this.throwContextError(error, function_id + ".1 : ")
    }
    log("step 4, multlist=", multlist, "timestamps=", multlist_timestamps)


    // --- retrieve latest history from whatsonchain ---

    // format of data will be : list of locations
    let locations = await fetch_tokkenr_node_for_address_token_history(owner_address, tokenoriginjig.origin)
    if (!locations) locations = []  // don't add new transactions to history but set to empty array to avoid breaking the app
    this.history_size = locations.length
    log("fetching found", this.history_size, "transactions in address history")


    // --- load the new transactions that are not yet in cache ---

    let unconfirmed_tokens_txdata = []

    this.history_nbloaded = 0


    try {
        for (var location of locations) { // pour chaque transaction dans l'historique

            // call /status/txhash to get height, time, executable, outputs[].state (if it exists)
            // (or we could also call /jig/location to get the computed state for each location)
            // we also need to check if the tx is unconfirmed or not

            let txhash = location.split("_")[0]

            let txh_status_data = await fetch_tokkenr_node_for_status_txhash(txhash)
            log("txh_status_data for ", location, ":", txh_status_data)

            let tx_height = txh_status_data.height
            log("tx_height for ", location, ":", tx_height)

            /* just checking if the tx is in cache is not enough, because there are many other
               transactions that the history may contain that are not actually token sending transactions
               (could be tx from bugs for example)
               so checking the block_height first makes it faster by ignoring old txs that we already ignored
               in the cache, AND after that you check if it is in the cache */

            /* we don't care if the tx is in cache, because it can be an invalid tx anyway
             so we mostly care about the tx_height first and only then about if it's in cache (to not add it again) */
            const has_interesting_height = (tx_height <= 1 || tx_height >= this.wallet_history_cache.last_seen_height)
            const is_in_cache = this.wallet_history_cache.isTXhashInCache(txhash)
            const must_add_to_cache = has_interesting_height && !is_in_cache

            // load from blockchain if tx is unconfirmed or a new transaction
            if (must_add_to_cache) {
                log("not yet in wallet_history_cache:", txhash, "with is_in_cache=", is_in_cache,
                    ", tx_height=", tx_height, ">=?", this.wallet_history_cache.last_seen_height)

                /* beware there can be many txs at the same blockheight so we always set the cache last_seen_height
                    at height-1 for safety */
                this.wallet_history_cache.update_last_seen_height(tx_height - 1)
                log("this.wallet_history_cache.last_seen_height =", this.wallet_history_cache.last_seen_height)

                // query blockchain and add the outputs (locations) to add to the cache

                var finaltxdata_array = await parse_tx_states_to_txdata_array(
                    txh_status_data,
                    myrun, txhash, totalmult, tokenoriginjig, multlistjig.origin, blacklistjig.origin,
                    revokercontract.origin, multlist, multlist_timestamps)

                log("finaltxdata_array for txhash ", txhash, ":", finaltxdata_array)

                for (let finaltxdata of finaltxdata_array) {

                    if (finaltxdata != null) {
                        // if the transaction is confirmed let's add it to the file cache
                        const tx_is_in_cache = this.wallet_history_cache.isLocationInCache(finaltxdata.location)
                        const should_add_to_cache = finaltxdata.blockheight
                            && finaltxdata.blockheight > 1
                            && !tx_is_in_cache

                        if (should_add_to_cache) {
                            try {
                                this.wallet_history_cache.add_entries(finaltxdata)
                                log("successfully added", txhash, "to wallet_history_cache, new size =",
                                    this.wallet_history_cache.size)
                            }
                            catch (error) {
                                this.throwContextError(error, function_id + ".5 : ")
                            }
                        }
                        else if (!tx_is_in_cache) {  // unconfirmed transaction
                            unconfirmed_tokens_txdata.push(finaltxdata)
                            log("successfully retrieved unconfirmed tx", finaltxdata)
                        }
                    }
                }
            }
            this.history_nbloaded += 1
        }
    } catch (error) {
        this.throwContextError(error, function_id + ".4 : ")
    }

    let tokens_txdata = this.wallet_history_cache.get_cache_array()

    // add unconfirmed transactions
    tokens_txdata = tokens_txdata.concat(unconfirmed_tokens_txdata)
    tokens_txdata = removeDupsInArray(tokens_txdata)

    log("# of txs in history (new + cached): ", tokens_txdata.length)
    log("tokens_txdata.slice(1,5)", tokens_txdata.slice(1, 5), "\n total length=", tokens_txdata.length)

    // safety check: order history based on timestamp
    tokens_txdata.sort(function(a, b) { return a.timestamp - b.timestamp })

    this.setState({ tokens_txdata: tokens_txdata })

    log("end")
    return tokens_txdata
}








/**
 * loads the history of this wallet's transactions (slower version)
 */
async function get_tx_history_old() {
    let function_id = this.classname + "get_tx_history_old(): "
    let log = getLog(function_id)

    get_tx_history_loadfromblockchain = get_tx_history_loadfromblockchain.bind(this)

    // Dont do this! we still need to be able to sync
    // abort if we need to exchange tokens
    // if (this.state.revokedetected) throw new Error(function_id + "aborting because revokedetected")

    if (!this.wallet_history_cache) throw new Error(function_id + "missing this.wallet_history_cache")

    const cache_size =  this.wallet_history_cache.size
    log("wallet_history_cache.size:", this.wallet_history_cache.size,
        "wallet_history_cache.last_seen_height=", this.wallet_history_cache.last_seen_height)

    var myrun = null, owner_address = null, totalmult = null, multlistjig = null,
        multlist = null, multlist_timestamps = null, tokenoriginjig, blacklistjig, revokercontract


    // --- retrieve needed components ---

    log("step 1")
    try {
        // parallel calls for faster app
        var [myrun, tokenoriginjig, multlistjig, totalmult] = await Promise.all([
            await this.runContext.get_run_asyncf(),
            this.get_tokenoriginjig(),
            this.get_multlistjig_synced(),
            this.get_total_mult(),
        ])

        owner_address = myrun.owner.address
        log = getLog(function_id + "for " + owner_address + " :")  // udpate log function with more info

        // REMINDER: NEVER LOG RUN IT CONTAINS PRIVKEYS
        log("tokenoriginjig=", tokenoriginjig, ", multlistjig=", multlistjig, ", totalmult=", totalmult)
        log("step 2")

        await tokenoriginjig.sync()
        log("step 3")

        blacklistjig = tokenoriginjig.blacklist
        if (!blacklistjig) throw new Error(function_id + " no blacklist found in tokenoriginjig")

        revokercontract = tokenoriginjig.revokercontract
        if (!revokercontract) throw new Error(function_id + " no revokercontract found in tokenoriginjig")

        multlist = deepcopy(multlistjig.list)
        multlist_timestamps = deepcopy(multlistjig.timestamps)
    }
    catch (error) {
        this.throwContextError(error, function_id + ".1 : ")
    }
    log("step 4, multlist=", multlist, "timestamps=", multlist_timestamps)


    // --- retrieve latest history ---

    // format of data will be : [{height:..., tx_hash:...}, ...]
    let data = await fetch_latest_history(this.state.network, owner_address)
    if (!data) data = []  // don't add new transactions to history but set to empty array to avoid breaking the app
    this.history_size = data.length
    log("fetching found", this.history_size, "transactions in address history: ", data)


    // --- load the new transactions that are not yet in cache ---

    let unconfirmed_tokens_txdata = []

    this.history_nbloaded = 0
    try {
        for (var idx in data)  // pour chaque transaction dans l'historique
        {
            let txhash = data[idx].tx_hash
            let tx_height = data[idx].height

            /* just checking if the tx is in cache is not enough, because there are many other
               transactions that the history may contain that are not actually token sending transactions
               (could be tx from bugs for example)
               so checking the block_height is much faster and more efficient AND after that you check
               if it is in the cache
            */

            const is_in_cache = this.wallet_history_cache.isTXhashInCache(txhash)

            /* we don't care if the tx is in cache, because it can be an invalid tx anyway
             so we mostly care about the tx_height first and only then about if it's in cache (to not add it again) */
            /* // deprecated in 2026 bc it was preventing history to load properly
            const has_interesting_height = (
                !tx_height
                || tx_height <= 1
                || tx_height >= this.wallet_history_cache.last_seen_height
            )
            const must_add_to_cache = has_interesting_height && !is_in_cache
            */
            const must_add_to_cache = !is_in_cache

            log("must_add_to_cache=", must_add_to_cache, "\n is_in_cache=", is_in_cache,
                "\n this.wallet_history_cache.last_seen_height=", this.wallet_history_cache.last_seen_height,
                "\n tx_height=", tx_height)

            // load from blockchain if tx is unconfirmed or a new transaction
            if (must_add_to_cache) {
                log("not yet in wallet_history_cache:", txhash, "with is_in_cache=", is_in_cache,
                    ", tx_height=", tx_height, ">=?", this.wallet_history_cache.last_seen_height)

                /* beware there can be many txs at the same blockheight so we always set the cache last_seen_height
                    at height-1 for safety */
                this.wallet_history_cache.update_last_seen_height(tx_height - 1)
                log("this.wallet_history_cache.last_seen_height =", this.wallet_history_cache.last_seen_height)

                // query blockchain and add the outputs (locations) to add to the cache

                var finaltxdata_array = await get_tx_history_loadfromblockchain(
                    myrun, txhash, totalmult, tokenoriginjig, multlistjig.origin, blacklistjig.origin,
                    revokercontract.origin, multlist, multlist_timestamps)
                log("finaltxdata_array for txhash ", txhash, ":", finaltxdata_array)

                for (let finaltxdata of finaltxdata_array) {

                    if (finaltxdata != null) {
                        // if the transaction is confirmed let's add it to the file cache
                        const tx_is_in_cache = this.wallet_history_cache.isLocationInCache(finaltxdata.location)
                        const should_add_to_cache = finaltxdata.blockheight
                            && finaltxdata.blockheight > 1
                            && !tx_is_in_cache

                        if (should_add_to_cache) {
                            try {
                                this.wallet_history_cache.add_entries(finaltxdata)
                                log("successfully added", txhash, "to wallet_history_cache, new size =",
                                    this.wallet_history_cache.size)
                            }
                            catch (error) {
                                this.throwContextError(error, function_id + ".5 : ")
                            }
                        }
                        else if (!tx_is_in_cache) {  // unconfirmed transaction
                            unconfirmed_tokens_txdata.push(finaltxdata)
                            log("successfully retrieved unconfirmed tx", finaltxdata)
                        }
                    }
                }
            }
            this.history_nbloaded += 1
        }
    } catch (error) {
        this.throwContextError(error, function_id + ".4 : ")
    }

    let tokens_txdata = this.wallet_history_cache.get_cache_array()

    // add unconfirmed transactions
    tokens_txdata = tokens_txdata.concat(unconfirmed_tokens_txdata)
    tokens_txdata = removeDupsByTxHashOrLocation(tokens_txdata)

    log("# of txs in history (new + "+cache_size+" cached): ", tokens_txdata.length)
    log("tokens_txdata.slice(1,5)", tokens_txdata.slice(1, 5), "\n total_length=", tokens_txdata.length)

    // safety check: order history based on timestamp
    tokens_txdata.sort(function(a, b) { return a.timestamp - b.timestamp })

    this.setState({ tokens_txdata: tokens_txdata })

    log("end")
    return tokens_txdata
}



async function fetch_latest_history(network, owner_address) {
    const function_id = "fetch_latest_history(" + network + ", " + owner_address + ")"
    const log = getLog(function_id)

    const start_time = Date.now()
    log("fetching latest history...")

    /* TODO add more fallbacks / alternatives to whatsonchain here
        but beware the node for now (02.2023) is not as up-to-date
        because it indexes with a delay + it filters some irrelevant ones
    */
   
    // format of data will be : [{height:..., tx_hash:...}, ...]
    let res = []

    /* // deprecated, now we fetch node first, WOC as fallback
    try {
        res = await fetch_latest_history_from_whatsonchain(network, owner_address)
        log("success | res=", res)
    } catch (e) {
        console.error(function_id + "catched Error: trying to load from fallback... (" + e + ")")
        try {
            res = await fetch_latest_history_from_tokkenr_node(network, owner_address)
            log("success with fallback | res=", res)
        } catch (e) {
            console.error(function_id + "catched Error: fallback failed... (" + e + ")")
        }
    }
    */
   // fetch node first, WOC as fallback
    try {
        res = await fetch_latest_history_from_tokkenr_node(network, owner_address)
        log("success from tokkenr node | res=", res)
    } catch (e) {
        console.error(function_id + "catched Error: trying to load from fallback... (" + e + ")")
        try {
            res = await fetch_latest_history_from_whatsonchain(network, owner_address)
            log("success with WoC as fallback | res=", res)
        } catch (e) {
            console.error(function_id + "catched Error: fallback failed... (" + e + ")")
        }
    }

    log("success after", (Date.now() - start_time), "ms | res.length=", res.length)
    return res || []
}



async function fetch_latest_history_from_tokkenr_node(network, owner_address) {
    const function_id = "fetch_latest_history_from_tokkenr_node(" + network + ", " + owner_address + ")"
    const log = getLog(function_id)
    log("called")

    const start_time = Date.now()

    // we send an explicit 'null' class_origin to get the whole history
    // format of data will be : list of location
    const locations = await fetch_tokkenr_node_for_address_token_history(owner_address, null)
    log("found", locations.length, "locations")

    // format of res must be : [{height:..., tx_hash:...}, ...]
    let res = []

    // for each tx_hash we retrieve it's blockheight
    const all_promises = []
    for (let location of locations) {
        const tx_hash = location.split('_')[0]
        all_promises.push((async (tx_hash) => {
            const tx_status = await fetch_tokkenr_node_for_tx_status(tx_hash)
            // log("fetched height=", tx_status.height, "for tx_hash=", tx_hash, "tx_status=", tx_status)
            return {
                tx_hash: tx_hash,
                height: tx_status.height,
                time: tx_status.time,  // fallback because some .height are null ?
            }
        })(tx_hash))  // important to execute the function here
    }
    res = await Promise.all(all_promises)

    // sort the res array by blockheight & time
    res = res.sort((x, y) => {
        // .time as fallback because some .height are null
        if (x.height && y.height) return x.height - y.height
        else return x.time - y.time
    })
    log("finished in", (Date.now() - start_time), "ms") // | after sort: res=", res.map(e => e.time))

    return res
}




async function fetch_latest_history_from_whatsonchain(network, owner_address) {
    const function_id = "fetch_latest_history_from_whatsonchain(" + network + ", " + owner_address + ")"
    const log = getLog(function_id)
    log("called")

    // wait for the shared WoC connector to be created by the wallet's first
    // reload_wallet() (it can race on app startup if this fires before the
    // run/blockchain stack is set up). Done ONCE here so the fetch retry loop
    // below only handles transient fetch failures, not the connector race.
    const wocConnector = await waitForSharedWhatsOnChainConnector()

    let data = null, retries = -1
    await retry(async () => {
        retries += 1

        try {
            log("fetching utxos in wallet from WoC connector")
            data = await wocConnector.fetchAddressHistory(owner_address)
            log("fetching utxos success:", data)
        }
        catch (error) {
            let errmess = function_id + ".2 failed fetching utxos (retries=" + String(retries) + ") from WoC connector"
                + " : String(data)=" + String(data) + " "
            console.error(errmess, error)
            throw new Error(errmess + error)
        }
    }, {
        retries: 3,
        minTimeout: 500,  // in ms
        factor: 2,  // exponential-backoff
    })

    return data
}

